import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';
import * as urlUtils from 'utils/url';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/survey_templates`,
  CATEGORY: `${apiUrlConfig.apiEndPoint()}/survey_template_categories`,
  CREATE: `${apiUrlConfig.apiEndPoint()}/survey_templates`,
  SHOW: `${apiUrlConfig.apiEndPoint()}/survey_templates/:id`,
  UPDATE: `${apiUrlConfig.apiEndPoint()}/survey_templates/:id`,
  DELETE: `${apiUrlConfig.apiEndPoint()}/survey_templates/:id`,
};

function insertIdToUrl(url, id) {
  return url.replace(':id', id);
}

class SurveyTemplateApi {
  /**
   * gets all categories
   */
  static getAll() {
    return AuthenticatedRequestService.get(URLS.INDEX);
  }

  static getAllCategories(dropdown) {
    const URL = urlUtils.addQueryParameters(URLS.CATEGORY, { dropdown });
    return AuthenticatedRequestService.get(URL);
  }

  /**
   * add new survey_template
   */
  static addNew(templateData) {
    const data = {
      survey_template: templateData,
    };

    return AuthenticatedRequestService.post(URLS.CREATE, data);
  }

  /**
   * get survey_template details
   */
  static getDetails(surveyTemplateId) {
    const SHOW_URL = insertIdToUrl(URLS.SHOW, surveyTemplateId);

    return AuthenticatedRequestService.get(SHOW_URL);
  }

  /**
   * updates survey_template
   */
  static update(templateId, templateData) {
    const UPDATE_URL = insertIdToUrl(URLS.UPDATE, templateId);

    const data = {
      survey_template: templateData,
    };

    return AuthenticatedRequestService.patch(UPDATE_URL, data);
  }

  /**
   * soft deletes survey_template
   * */
  static delete(templateId) {
    const DELETE_URL = insertIdToUrl(URLS.UPDATE, templateId);
    const data = {
      survey_template: {
        is_deleted: true,
      },
    };

    return AuthenticatedRequestService.patch(DELETE_URL, data);
  }
}

export default SurveyTemplateApi;



// WEBPACK FOOTER //
// ./src/apis/SurveyTemplate.js